import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { momentParse } from '../../utils/time';
import MaterialLink from '../material-link';
import consumeAppContext from '../../consumers/app';
import DeleteCommentLink from './delete-comment-link';
import Markdown from '../markdown';
import { eventStatusName } from '../../utils/event-status';

const useStyles = makeStyles((theme) => ({
  comment: {
    margin: theme.spacing(1, 0),
  },
  meta: {
    display: 'flex'
  },
  avatarLink: {
    marginRight: theme.spacing(1)
  },
  displayName: {
    display: 'flex',
    alignItems: 'center'
  },
  chip: {
    marginLeft: theme.spacing(1)
  },
  statusChip: {
    borderColor: `rgba(0, 0, 0, 0.2)`,
    color: '#333'
  },
  subName: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#222'
  },
  createdAt: {
    paddingTop: 1
  },
  deleteLink: {
    marginLeft: theme.spacing(1),
    '& > button': {
      paddingBottom: 2
    }
  },
  body: {
    margin: theme.spacing(2, 0, 2, 0),
  },
}));

const EventComment = ({ comment, event, isLoggedIn }) => {
  const classes = useStyles();
  const { membership } = comment;
  const createdAt = momentParse(comment.createdAt);

  return (
    <div className={classes.comment}>
      <div className={classes.meta}>
        <MaterialLink
          href="/people/[username]"
          as={`/people/${comment.user.username}`}
          className={classes.avatarLink}
        >
          <Avatar
            alt={comment.user.displayName}
            src={comment.user.avatar.small.url}
          />
        </MaterialLink>
        <div className={classes.main}>
          <div className={classes.displayName}>
            <MaterialLink
              href="/people/[username]"
              as={`/people/${comment.user.username}`}
            >
              {comment.user.displayName}
            </MaterialLink>

            {membership.isHost && (
              <Chip
                size="small"
                label="Host"
                className={classes.chip}
                color="primary"
              />
            )}
            {membership.status && (
              <Chip
                size="small"
                variant="outlined"
                label={eventStatusName(membership.status)}
                className={clsx(classes.chip, classes.statusChip)}
              />
            )}
          </div>
          <div className={classes.subName}>
            <time
              className={classes.createdAt}
              dateTime={createdAt.toString()}
              title={createdAt.format('dddd, MMMM Do, YYYY h:mm a')}
            >
              {createdAt.fromNow()}
            </time>
            {isLoggedIn && (
              <DeleteCommentLink comment={comment} event={event} />
            )}
          </div>
        </div>
      </div>
      <div className={classes.body}>
        <Markdown>{comment.body}</Markdown>
      </div>
    </div>
  );
};

EventComment.propTypes = {
  comment: PropTypes.object,
  event: PropTypes.object,
  isLoggedIn: PropTypes.bool,
};

export default consumeAppContext(EventComment);
